module.exports = __webpack_public_path__ + "img/5.72394dc9.png";